import { useState } from 'react';

import DeleteSubscriberModel from './Modal/DeleteSubscriberModel';

const SubscriberActionDropdown = (props) => {

    let data = props.data

    const [isOpenDeletePopup, setIsOpenDeletePopup] = useState(false);

    const handleDelete = () => {
        setIsOpenDeletePopup(true);
        document.body.classList.add('hidden-message')
        const dropdown = document.querySelector('.dropdown');
        dropdown.style.display = 'none';
    }

    const closeDeletePopup = () => {
        setIsOpenDeletePopup(false)
        document.body.classList.remove('hidden-message');
        props.togglePopup(null)
    }

    return (
        <>
        <div className='dropdown addDropdown dropdown-field'>
            <ul>
                <li onClick={() => { handleDelete(); }}><a href="#">Delete</a></li>
            </ul>
        </div>

        {isOpenDeletePopup && 
            <>
                <div className="welcomeOverlay"></div>
                <DeleteSubscriberModel isOpen={isOpenDeletePopup} onClose={closeDeletePopup} subsciberIds={[data._id]} hasPaidSubscription={data.plan !== 'freePlan'} fetchData={props.fetchData} setShowNotification={props?.setShowNotification} subscibersData={[data]} currencyData={props?.currencyData}/>
            </>
        }
        </>
    )

}

export default SubscriberActionDropdown;